<template>
  <div class="app-container">
    <div class="common-section-bg common-section-body">
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="160px"
        style="width: 500px;"
      >
        <el-form-item label="兑换比例" prop="exchange_points">
          <el-input
            v-model="form.exchange_points"
            type="number"
            placeholder="请输入多少积分兑换 1 元"
            min="1"
            style="width: 260px"
          >
            <template slot="append">积分 = 1 元</template>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            style="background:#1890ff;border-color:#1890ff"
            @click="submitForm"
          >
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import pointsconfig from "../../../api/tianzheng/pointsconfig";

export default {
  data() {
    return {
      form: {
        exchange_points: ""
      },
      rules: {
        exchange_points: [
          {required: true, message: "请输入兑换比例", trigger: "blur"},
          {
            type: "number",
            transform: (value) => Number(value),
            min: 1,
            message: "积分必须大于 0",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    // 获取配置
    getConfig() {
      pointsconfig.detail().then(res => {
        if (res.code === 200 && res.result) {
          this.form.exchange_points = res.result.exchange_points;
        }
      });
    },

    // 保存配置
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return;

        pointsconfig.edit(this.form).then(res => {
          if (res.code === 200) {
            this.$message.success("保存成功");
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
